<template>
  <div class="m-activity-prizeForm">
    <el-form v-if="prizesItem.isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="140px">
      <el-form-item label="奖品名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入奖品名称" maxlength="14" />
      </el-form-item>
      <el-form-item label="奖品类型" prop="type">
        <el-radio-group v-model="form.type" @change="onTypeChange">
          <el-radio label="Coupon" :disabled="!couponListData_Coupon">优惠券</el-radio>
          <el-radio label="GiftCoupon" :disabled="!couponListData_GiftCoupon">礼品券</el-radio>
          <el-radio label="LotCoupon" :disabled="!couponListData_LotCoupon">停车券</el-radio>
          <el-radio label="MemberPoint">积分</el-radio>
          <auth-button auth="market:deductcoupon:template:read">
            <el-radio label="SkuCoupon" :disabled="!couponListData_SkuCoupon">抵扣券</el-radio>
          </auth-button>
          <el-radio v-if="baseInfo.scene == 'CouponDeal'" label="RedPackRandom">随机红包</el-radio>
          <el-radio v-if="baseInfo.scene == 'CouponDeal'" label="RedPackFixed">固定红包</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="['Coupon', 'GiftCoupon', 'LotCoupon', 'SkuCoupon'].indexOf(form.type) >= 0" label="选择券" prop="couponTemplateId" ref="couponTemplateId">
        <el-select v-model="form.couponTemplateId" placeholder="请选择券" @change="onCouponChange" collapse-tags filterable>
          <el-option v-for="item in couponListRenderData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div v-if="['Coupon', 'GiftCoupon', 'LotCoupon', 'SkuCoupon'].indexOf(form.type) >= 0" class="coupon-table">
        <coupon-table :tableTrData="tableTrData" :couponType="form.type"></coupon-table>
      </div>
      <el-form-item v-if="form.type == 'MemberPoint'" label="中奖积分" prop="memberPointAmount">
        <el-input v-model.number="form.memberPointAmount" placeholder="请输入积分" oninput="value=value.replace(/[^\d]/g,'')" />
      </el-form-item>

      <el-form-item v-if="form.type === 'RedPackFixed'" label="金额" prop="redPackAmount" >
        <el-input v-model="form.redPackAmount" placeholder="请输入金额" oninput="value=value.replace(/[^.\d.]/g,'')"/>
      </el-form-item>
      <el-form-item v-if="form.type === 'RedPackRandom'" label="优惠上限" prop="redPackAmount" >
        <el-input v-model="form.redPackAmount" placeholder="请输入优惠上限" oninput="value=value.replace(/[^.\d.]/g,'')"/>
      </el-form-item>
      <el-form-item v-if="form.type === 'RedPackRandom'" label="红包比例" prop="redPackOrderRatio" >
        <el-input v-model="form.redPackOrderRatio" placeholder="请输入红包比例" oninput="value=value.replace(/[^.\d.]/g,'')">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="奖品图片" prop="iconKey">
        <UploadImg @getUploadFile="(file) => getUploadFile(file, form)" :uploadUrl="form.iconKey"></UploadImg>
      </el-form-item>
      <el-form-item label="奖品总数量" prop="amount">
        <el-input :disabled="tableTrData[0] ? tableTrData[0].issueType == 'Stock' : false" v-model.number="form.amount" placeholder="请输入奖品总数量" oninput="value=value.replace(/[^\d]/g,'')" />
      </el-form-item>
      <el-form-item label="奖品概率" prop="probability">
        <el-input v-model="form.probability" placeholder="请输入奖品概率" oninput="value=value.replace(/[^\d]/g,'')" >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <prizes-advanced-set
        :form="form"
        :baseInfo="baseInfo"
        :mallData="mallData"
        ref="prizes_advanced_set"
        @onMemberChange="onMemberChange"
      />
    </el-form>

    <prizes-form-detail
      v-else-if="form.id"
      :baseInfo="baseInfo"
      :prizeTypeObjData="prizeTypeObjData"
      :form="form"
      :tableTrData="tableTrData"
    />
    <div class="submit-btn">
      <div v-if="prizesItem.isEdit">
        <el-button @click="onCancel" class="mr20">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
      </div>
      <div v-else-if="isCanEdit">
        <auth-button auth="market:activity:update">
          <el-button type="primary" @click="onEdit">编辑</el-button>
        </auth-button>
      </div>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import couponTable from '../../components/couponTable.vue'
import prizesAdvancedSet from './prizesAdvancedSet.vue'
import prizesFormDetail from './prizesFormDetail.vue'
import { api_postPrizeAdd, api_postPrizeUpdate, api_getCouponDetail, api_getGiftCouponDetail, api_getDeductCouponTemplate } from '@/api/market'
import { api_postFileUpload } from '@/api/common'
import { api_getParkingCouponDetail } from '@/api/parking'

export default {
  name: "marketActivityListPrizeForm",
  components: {
    AuthButton,
    UploadImg,
    couponTable,
    prizesAdvancedSet,
    prizesFormDetail
  },
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    sumProbability: {
      type: Number,
      default() {
        return 0
      }
    },
    prizesItem: {
      type: Object,
      default() {
        return {}
      }
    },
    prizesIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    tabsKey: {
      type: String,
      default() {
        return ''
      }
    },
    isCanEdit: {
      type: Boolean,
      default() {
        return true
      }
    },
    mallData: {
      type: Array,
      default() {
        return []
      }
    },
    couponListData_Coupon: {
      tyoe: Array,
      default() {
        return []
      }
    },
    couponListData_GiftCoupon: {
      tyoe: Array,
      default() {
        return []
      }
    },
    couponListData_LotCoupon: {
      tyoe: Array,
      default() {
        return []
      }
    },
    couponListData_SkuCoupon: {
      tyoe: Array,
      default() {
        return []
      }
    },
  },
  data() {
    // 校验奖品图片
    const checkIconKey = (rule, value, callback) => {
      if (!this.form.iconKey) {
        callback(new Error('请上传奖品图片'))
      } else {
        callback()
      }
    }

    // 校验正整数
    const checkInt = (rule, value, callback) => {
      const check = /(^[0-9]\d*$)/;
      if (!check.test(value)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }

    // 校验中奖概率
    const checkProbability = (rule, v, callback) => {
      let value = parseFloat(v)
      const reg = /^(0|[1-9]\d*)(.\d{1,2})?$/ // 校验数字（大于等于0，最多两位小数）
      if (!v) {
        callback(new Error('请输入中奖概率'))
      } else if (!reg.test(value) || value > 100) {
        callback(new Error('请输入0~100之间的数字，最多保留两位小数'))
      } else if (value > this.usableProbability) {
        callback(new Error('所有奖品的中奖概率不能大于100%'))
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      curPrizesListData: [],
      form: {
        userWhitelist: [],
        amount: null,
      },
      usableProbability: 0, // 当前奖品的可用概率
      rules: {
        name: [{ required: true, message: '请输入奖品名称' }],
        type: [{ required: true, message: '请选择奖品类型' }],
        memberPointAmount: [{ validator: checkInt }],
        description: [{ required: true, message: '请输入兑奖说明' }],
        randomAmount: [{ required: true, message: '请输入' }],
        upperLimit: [{ required: true, message: '请输入优惠上限' }],
        envelopeRatio: [{ required: true, message: '请输入' }],
        openAdvancedSet: [{ required: true, message: '请选择' }],
        iconKey: [{ validator: checkIconKey }],
        amount: [{ validator: checkInt }],
        probability: [{ validator: checkProbability }],
        mallIds: [{ required: true, message: '请选择商场' }],
        advanceControl: [{ required: true, message: '请选择' }],
        userTotalLimit: [{ required: true, message: '请输入次数' }],
      },

      prizeTypeData: [
        {name: '优惠券', value: 'Coupon'},
        {name: '礼品券', value: 'GiftCoupon'},
        {name: '停车券', value: 'LotCoupon'},
        {name: '积分', value: 'MemberPoint'},
      ],
      prizeTypeObjData: {
        'Coupon': '优惠券',
        'GiftCoupon': '礼品券',
        'LotCoupon': '停车券',
        'MemberPoint': '积分',
        'SkuCoupon': '抵扣券',
        'Other': '其他',
        'RedPackRandom': '随机红包',
        'RedPackFixed': '固定红包'
      }, // 奖品类型枚举数据
      couponListRenderData: [],

      tableTrData: []
    };
  },
  async created() {
    this.initCurForm() // 初始化当前表单
  },
  methods: {
    // 初始化当前表单
    initCurForm() {
      this.form = {
        advanceControl: false,
        ...this.prizesItem,
        mallIds: this.prizesItem.prizeMallDeployList ? this.prizesItem.prizeMallDeployList.map(item => item.mallId) : [],
        userWhitePhone: this.prizesItem.userWhitelist ? this.prizesItem.userWhitelist.map(item => item.phone).join('，') : '',
        userWhiteSelected: this.prizesItem.userWhitelist || [],
        userWhitelist: this.prizesItem.userWhitelist ? this.prizesItem.userWhitelist.map(item => item.id) : [],
      }

      if (this.form.id && this.form.isEdit && this.form.mallIds.length) {
        setTimeout(() => {
          this.$refs['prizes_advanced_set'].getEditDetail(this.prizesItem.prizeMallDeployList)
        }, 300)
      }

      // 计算当前奖品的可用中奖概率
      const itemProbability = this.prizesItem.probability || 0
      this.usableProbability = 100 - this.sumProbability + itemProbability

      if (this.form.id && this.form.couponTemplateId) {
        if (['Coupon', 'GiftCoupon', 'LotCoupon', 'SkuCoupon'].indexOf(this.form.type) >= 0) {
          this.couponListRenderData = this['couponListData_' + this.form.type]
        }
        this.getCouponDetail(this.form.couponTemplateId)
      }
    },

    // 奖品类型改变
    onTypeChange(value) {
      console.log('value: ', value);
      if (['Coupon', 'GiftCoupon', 'LotCoupon', 'SkuCoupon'].indexOf(value) >= 0) {
        this.couponListRenderData = this['couponListData_' + value]
        this.tableTrData = []
        this.form = {
          ...this.form,
          couponTemplateId: null
        }
      }
    },

    // 券下拉框改变
    onCouponChange(value) {
      const curCoupon = this['couponListData_' + this.form.type].filter(item => item.id == value)
      this.form = {
        ...this.form,
        amount: curCoupon[0].stock || curCoupon[0].stock === 0 ? curCoupon[0].stock : null
      }
      this.tableTrData = curCoupon
    },

    // 获取券详情
    async getCouponDetail(couponTemplateId) {
      const { type } = this.form
      let res = []
      if (type === 'Coupon') {
        res = await api_getCouponDetail({id: couponTemplateId})
      } else if (type === 'GiftCoupon') {
        res = await  api_getGiftCouponDetail({id: couponTemplateId})
        // res.id ? this.form.amount = res.stock : ''
      } else if (type === 'LotCoupon') {
        res = await api_getParkingCouponDetail({id: couponTemplateId})
      } else if (type === 'SkuCoupon') {
        res = await api_getDeductCouponTemplate({id: couponTemplateId})
      }
      this.tableTrData = res.id ? [res] : []
    },

    // 白名单会员
    onMemberChange(value) {
      this.form.userWhitelist = value
    },

    // 点击编辑按钮
    onEdit() {
      this.$emit('onIsEdit', true)
    },

    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // this.submitLoading = true
          try {
            let params = {
              ...this.form,
              activityId: this.$route.query.id
            }
            if (this.form.iconKey.size) {
              const { key } = await api_postFileUpload(this.form.iconKey, 'PrizeLogo')
              params.iconKey = key
            }

            params.advanceControl && (params.prizeMallDeployList = this.$refs['prizes_advanced_set'].prizeMallDeployList)
            const validateResult = this.validateMallDeployList(params) // 校验商场投放列表
            if (validateResult) {
              this.$baseMessage(validateResult, 'warning')
              this.submitLoading = false
              return
            }

            delete params.mallIds
            delete params.isEdit
            console.log('params: ', params);
            // return

            let res = params.id ? await api_postPrizeUpdate(params) : await api_postPrizeAdd(params)
            console.log('res: ', res);


            this.$emit('onIsEdit', false)
            this.$emit('getPrizeData')
            this.submitLoading = false
          } catch (err) {
            console.log('err: ', err);
            this.submitLoading = false
          }
        }
      })
    },

    // 校验商场投放列表
    validateMallDeployList(params) {
      const { advanceControl, userTotalLimit, amount, prizeMallDeployList=[], userWhitelist=[] } = params
      const sum = prizeMallDeployList.reduce((total, item) => total + (item.deployLimit * 1), 0) // 商场总投放数量
      let userWhiteNum = userWhitelist ? userWhitelist.length : 0 // 白名单会员总数
      if (advanceControl && ((sum + userWhiteNum * userTotalLimit) > amount)) {
        return '(白名单会员数 * 每人可中奖次数 + 商场投放总数量) 不能大于 奖品总数量'
      } else {
        return ''
      }
    },

    // 图片上传事件
    getUploadFile (file, form) {
      form.iconKey = file
    },

    // 点击取消
    onCancel() {
      if (this.form.id) {
        this.$emit('onIsEdit', false)
      } else {
        this.$emit('delPrizeOk', this.prizesIndex)
      }
    },
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped>
.m-activity-prizeForm {
  width: 100%;
  position: relative;

  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;

      .img {
        border: 1px solid #eee;
        border-radius: 2px;
        width: 150px;
        height: 150px;
      }
    }
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .coupon-table {
    width: 80%;
    margin-left: 140px;
    margin-bottom: 20px;
  }

  .submit-btn{
    text-align: right;
    margin-top: 20px;
  }
}
</style>
